import {
  EMAIL_DOMAIN_CORRECTION_MAP,
  EMAIL_VALIDATION_PATTERN
} from "../../views/authentication/constants";

export const validateEmail = ({ email, trans, isSuggestEmailDomain }) => {
  if (!email) {
    return trans("Email is required.");
  }
  email = email.trim().toLowerCase();
  if (!isValidEmailFormat(email)) {
    return trans("This is not a valid email.");
  }
  if (isSuggestEmailDomain) {
    return suggestEmailDomain(email, trans);
  }
  return null;
};

/**
 * TEMPORARY: As part of the suggest email domain epic, we're moving the
 * validation API check to the browser to test whether it has any impact
 * on signup traffic. Remove this once the experiment concludes.
 */
export const validateEmailServer = email =>
  fetch(`/api/v3/users/validate?email=${encodeURIComponent(email.trim())}`)
    .then(res => {
      if (res.ok) {
        return null;
      }
      return res.json().then(err => {
        if (err?.error_type !== "InvalidValue") {
          return null;
        }
        if (err.error_code === 1174) {
          return err.message + ":isEmailDomainSuggestion";
        }
        return err.message;
      });
    })
    .catch(() => null);

const isValidEmailFormat = email => {
  const regex = EMAIL_VALIDATION_PATTERN;
  return new RegExp(regex).test(email);
};

const suggestEmailDomain = (value, t) => {
  const correctionMap = EMAIL_DOMAIN_CORRECTION_MAP;

  const [localPart, domain] = value.split("@");

  if (!localPart || !domain) {
    return null;
  }

  const correctedDomain = correctionMap[domain.toLowerCase()];

  if (!correctedDomain) {
    return null;
  }

  return (
    t("Did you mean:") +
    ` ${localPart}@${correctedDomain}:isEmailDomainSuggestion`
  );
};

export const parseSuggestedEmailMessage = message => {
  const [msg, suggestion] = message.split(":");

  return {
    msg: msg.trim() + ":",
    suggestion: suggestion.trim()
  };
};
